import { ID } from '@ianesthesie-kit/services';
import { BloodManagement } from './bloodManagement.model';
import { PatchableMedicalService } from '../patchableMedical.service';

export class BloodManagementService extends PatchableMedicalService<BloodManagement> {
  private static INSTANCE_BY_ID: BloodManagementService;

  private constructor(patientId: string) {
    super('/blood-management', patientId);
  }

  public static getInstance(patientId: ID): BloodManagementService {
    if (this.shouldCreateNewInstance(this.INSTANCE_BY_ID, patientId)) {
      this.INSTANCE_BY_ID = new BloodManagementService(patientId);
    }

    return this.INSTANCE_BY_ID;
  }
}
